import EmitenAccounts from "./EmitenAccounts";
import { Tabs, Tab } from "@mui/material";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import { Box, Button, Chip, Divider, Drawer, Stack, Typography } from '@mui/material'
import { useLayout } from "components/layout/LayoutComponentContext";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import storage from "services/storage";
import { useMemo, useState } from "react";
import { deleteAccountInternal } from "features/account/service/AccountProfileService";
import { useSnackbar } from "components/snackbar/SnackbarContext";


export default function UserManagementList({
    isOpen,
    onBack,
    onClose,
    onOpenCreateAccount,
    onOpenEditAccount,
}) {
    const [accountTab,setAccountTab] = useState("internal");
    const [deleteUserId, setDeleteUserId] = useState(null);
    const { companyProfile, admin } = useLayout()
    const typeStorage = storage.getItem("type");
    const usersToDisplay = typeStorage === "CLIENT" ? (companyProfile?.company_users || []) : (admin || [])
    const { setMessage } = useSnackbar();
    const { refetchUserBasedOnType } = useLayout()

    const isAccountLimitReached = useMemo(() => {
        const activeUsers = usersToDisplay.filter(item => item.status === "ACTIVE").length
        if (typeStorage === "CLIENT") {
            if (companyProfile.subscription_type === "PRO") {
                return activeUsers >= 5;
            } else {
                return activeUsers >= 2;
            }
        }
        return false
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [usersToDisplay])

    const handleDeleteAccount = async (id) => {
        const response = await deleteAccountInternal(id)
        if (response?.info?.title) {
            setMessage({
                title: "Success",
                desc: "Account deleted",
                type: "success",
            });
            refetchUserBasedOnType()
        } else {
            setMessage({
                title: "Failed",
                desc: response,
                type: "error",
            });
        }
    }

    return (
        <Drawer
            className="account-profile-drawer"
            anchor="right"
            open={isOpen}
            onClose={onClose}
        >
            <Stack className="header" direction="row" justifyContent="space-between" alignItems="center">
                <img alt='close-profile-icon' className='cursor-pointer' src='/images/sidebar/sidebar-back.svg' onClick={onBack} />
                <p className='account-profile-title'>User Management</p>
                <img alt='close-profile-icon' className='cursor-pointer' src='/images/close-profile-icon.svg' onClick={onClose} />
            </Stack>
            <Stack className="container !pt-0" spacing={3}>
                {typeStorage === "ADMIN" ? <Tabs value={accountTab} onChange={(_,v)=>setAccountTab(v)}><Tab value="internal" label="Qaptive Admin"/><Tab value="emiten" label="Emiten Accounts"/></Tabs> : <Typography fontWeight={600}>Emiten Accounts — {companyProfile?.name}</Typography>}
                {typeStorage === "ADMIN" && accountTab === "emiten" ? <EmitenAccounts /> : <>
                {usersToDisplay ? (
                    <Stack divider={<Divider />}>
                        {usersToDisplay.map((user) => {
                            return (
                                <Stack key={user.id} className='w-full'>
                                    <Stack className="py-4" spacing={3}>
                                        <Stack direction='row' justifyContent='space-between' alignItems='center'>
                                            <Stack direction='row' spacing={2} alignItems='center'>
                                                {user?.avatar_path ? (
                                                    <img
                                                        alt="account-profile-image"
                                                        src={user.avatar_path}
                                                        className='w-10 h-10 rounded-full shrink-0 object-cover'
                                                    />
                                                ) : (
                                                    <AccountCircleRoundedIcon
                                                        viewBox="2 2 20 20"
                                                        aria-label='account-profile-image-default'
                                                        className="p-0"
                                                        sx={{ height: "40px", width: "40px", color: "#ccc" }}
                                                    />)
                                                }
                                                <Stack spacing={1} justifyContent='center'>
                                                    <Typography fontWeight={600} fontSize={14}>{user?.name}</Typography>
                                                    <Stack direction='row' alignItems='center' spacing={1}>
                                                        <Typography fontSize={12} color='#5F737F' className='capitalize'>
                                                            {user?.role === "COMPANY ADMIN"
                                                                || user?.role === "COMPANY USER" ? (user.role === "COMPANY ADMIN" ? "Emiten Admin" : "Emiten User") : `Qaptive ${user?.role.toLowerCase()}`}
                                                        </Typography>
                                                        <Box className='rounded-full h-1 w-1 bg-[#5F737F]'></Box>
                                                        {user?.status === 'ACTIVE' ? (
                                                            <Chip
                                                                className='capitalize !bg-[#CAFAD2] !text-[#039E5A] !font-medium'
                                                                size='small'
                                                                label={user?.status.toLowerCase()}>
                                                            </Chip>
                                                        ) : (
                                                            <Chip
                                                                className='capitalize !bg-[#FDDCD3] !text-[#E52A49] !font-medium'
                                                                size='small'
                                                                label={user?.status.toLowerCase()}>
                                                            </Chip>
                                                        )}
                                                    </Stack>
                                                </Stack>
                                            </Stack>
                                            {user?.is_editable_by_requester &&
                                                <Stack direction='row' spacing={1}>
                                                    <EditOutlinedIcon
                                                        className="text-[#FBD603] cursor-pointer"
                                                        onClick={() => onOpenEditAccount(user)}
                                                    />
                                                    {typeStorage !== "CLIENT" &&
                                                        <DeleteOutlineIcon
                                                            className="text-[#E52A49] cursor-pointer"
                                                            onClick={() => setDeleteUserId(user.id)} />}
                                                </Stack>
                                            }
                                        </Stack>
                                        {deleteUserId === user.id && (
                                            <Stack className="rounded-lg border py-6 px-5 border-[#B5BFC4]" direction='row'>
                                                <Typography fontSize={12}>Are you sure you want to delete this account?</Typography>
                                                <Stack spacing={2} direction="row" justifyContent="flex-end" width="100%">
                                                    <Button
                                                        color='secondary'
                                                        variant='outlined'
                                                        onClick={() => setDeleteUserId(null)}
                                                    >
                                                        <Typography fontSize={12} fontWeight={800}>Cancel</Typography>
                                                    </Button>
                                                    <Button
                                                        variant='contained'
                                                        className='!bg-[#556FB5] w-[100px]'
                                                        onClick={() => handleDeleteAccount(user.id)}
                                                    >
                                                        <Typography fontSize={12} fontWeight={800}>Yes</Typography>
                                                    </Button>
                                                </Stack>
                                            </Stack>)}
                                    </Stack>
                                </Stack>
                            )
                        })}
                    </Stack>
                ) : (
                    <Stack justifyContent='center' alignItems='center' spacing={2} className="flex-1">
                        <img
                            alt='empty-admin-icon'
                            src='/images/admin-empty-state.svg'
                        />
                    </Stack>
                )}
                <Stack spacing={2}>
                    {isAccountLimitReached && <Box className='bg-[#FCEAED] p-2.5 rounded-lg text-center'>
                        <Typography fontSize={12} display='inline'>Maximum account limit reached. </Typography>
                        {companyProfile?.subscription_type !== "PRO" &&
                            (
                                <>
                                    <Typography fontSize={12} display='inline' fontWeight={800} color='#556FB5'>Upgrade to PRO </Typography>
                                    <Typography fontSize={12} display='inline'>to add more account.</Typography>
                                </>
                            )}
                    </Box>}
                    <Button
                        className='!bg-[#556FB5] disabled:!bg-[#B5BFC4]'
                        onClick={onOpenCreateAccount}
                        disabled={isAccountLimitReached} variant='contained'
                    >
                        <Typography fontSize={12} fontWeight={800}>Create New Account</Typography>
                    </Button>
                </Stack>
                </>}
            </Stack>
        </Drawer>
    )
}